import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/index.css'
import 'swiper/css'

import 'element-ui/lib/theme-chalk/index.css';

import ElementUI from 'element-ui';
import VueMeta from 'vue-meta'
import '@/assets/element-override.css';
Vue.use(ElementUI);
Vue.use(VueMeta)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')